import React from "react";
import "./floatingPopulationModal.css";
import Header from "./Header";
import PlaceFloatingPopulation from "./PlaceFloatingPopulation";
import PlaceFloatingPopulationDetail from "./PlaceFloatingPopulationDetail";
import CrowdedStepGuideModal from "./CrowdedStepGuideModal";
import {IPeopleCountMarker} from "../../../constants/list/PeopleCountMarkerList";

interface Props {
  item: IPeopleCountMarker;
}
interface State {
  isCrowdedStepGuideModalOpen: boolean;
}

export default class FloatingPopulationModal extends React.Component<Props, State> {

  openCrowdedStepGuideModal = () => this.setState({isCrowdedStepGuideModalOpen: true});
  closeCrowdedStepGuideModal = () => this.setState({isCrowdedStepGuideModalOpen: false});

  state: State = {
    isCrowdedStepGuideModalOpen: false,
  }

  render() {
    const {isCrowdedStepGuideModalOpen} = this.state;
    return (
      <>
        <div className={"floating-population-modal"}>
          <Header />
          <PlaceFloatingPopulation openCrowdedStepGuideModal={this.openCrowdedStepGuideModal} item={this.props.item}/>
          <PlaceFloatingPopulationDetail />
        </div>
        {isCrowdedStepGuideModalOpen && <CrowdedStepGuideModal closeCrowdedStepGuideModal={this.closeCrowdedStepGuideModal}/>}
      </>
    );
  }
}
